import { createSlice } from '@reduxjs/toolkit';
import { normalizeDataWarehouse } from './operations';
import { postNewWarehouseAsync } from 'features/warehouses/warehousesSlice';
import { delByPathIdDevicesAsync } from 'features/devices/devicesSlice';
import { getWarehouseAsync, putWarehouseInfoAsync } from './asyncActions';

export interface WarehouseDetailState {
  warehouseData: {
    data: null | any;
    status: null | 'idle' | 'loading' | 'failed';
  };
  newWarehouse: any;
  updateWarehouse: any;
}

const initialState: WarehouseDetailState = {
  warehouseData: {
    data: null,
    status: null,
  },
  newWarehouse: null,
  updateWarehouse: null,
};

export const warehouseDetailSlice = createSlice({
  name: 'warehouseDetail',
  initialState,
  reducers: {
    resetWarehouse: (state) => {
      state.warehouseData.data = null;
      state.warehouseData.status = null;
      state.newWarehouse = null;
      state.updateWarehouse = null;
    },
    resetNewWarehouse: (state) => {
      state.newWarehouse = null;
    },
    resetUpdateWarehouse: (state) => {
      state.updateWarehouse = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getWarehouseAsync.pending, (state) => {
        state.warehouseData.status = 'loading';
      })
      .addCase(getWarehouseAsync.fulfilled, (state, action) => {
        state.warehouseData.status = 'idle';
        state.warehouseData.data = normalizeDataWarehouse(action.payload);
      })
      .addCase(getWarehouseAsync.rejected, (state) => {
        state.warehouseData.status = 'failed';
      })
      .addCase(putWarehouseInfoAsync.fulfilled, (state, action) => {
        state.warehouseData.data = action.meta.arg;
        state.updateWarehouse = action.payload?.data?.success;
      })
      .addCase(postNewWarehouseAsync.fulfilled, (state, action) => {
        state.newWarehouse = action.payload?.data?.success;
      })
      .addCase(delByPathIdDevicesAsync.fulfilled, (state, action) => {
        if (state.warehouseData.data?.devices) {
          state.warehouseData.data.devices = state.warehouseData.data.devices.filter(
            (device: any) => device.id !== action.meta.arg.id,
          );
        }
      });
  },
});

export const { resetWarehouse, resetNewWarehouse, resetUpdateWarehouse } = warehouseDetailSlice.actions;

export default warehouseDetailSlice.reducer;
